






















declare global {
  interface Window {
    kakao: any;
  }
}
import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseComponent from './core/base.component';
import store from '@/store';

@Component({
  name: 'App',
})
export default class extends Vue {
  // private showSnackBar = false;
  // get layout
  get layout() {
    return this.$route.meta.layout;
  }
}
